import { useCallback } from 'react';

import { SortDirection } from '@air/types';

import { type UsePrivateBoardsListParams } from '~/components/v2/hooks/queries/usePrivateBoardsList';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

export const useFavoriteBoardsParams = () => {
  const { currentWorkspace } = useCurrentWorkspace();

  const getFavoriteBoardsParams = useCallback((): UsePrivateBoardsListParams => {
    return {
      includeDirectDescendantCount: true,
      includeDirectDescendantBoardCount: true,
      isMemberOfBoard: 'YES',
      limit: 100,
      numThumbnails: 0,
      sortField: {
        direction: SortDirection.desc,
        name: 'customSort',
      },
      workspaceId: currentWorkspace?.id,
    };
  }, [currentWorkspace?.id]);

  return { getFavoriteBoardsParams };
};
